import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "lock_d7074",
  "use": "lock_d7074-usage",
  "viewBox": "0 0 12 15",
  "content": "<symbol viewBox=\"0 0 12 15\" id=\"lock_d7074\">\n    <g fill=\"inherit\">\n        <ellipse cx=\"6\" cy=\"9.375\" rx=\"1\" ry=\"1\" />\n        <path d=\"M6 11.875c-.184 0-.333-.14-.333-.313V9.688c0-.173.149-.313.333-.313.184 0 .333.14.333.313v1.874c0 .173-.149.313-.333.313z\" />\n        <path d=\"M12 15H0V5.625h12V15zM.667 14.375h10.666V6.25H.667v8.125z\" />\n        <path d=\"M10 5.938h-.667V3.75C9.333 2.027 7.838.625 6 .625S2.667 2.027 2.667 3.75v2.188H2V3.75C2 1.682 3.794 0 6 0s4 1.682 4 3.75v2.188z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol